import React from 'react';
import './QuestionNavButtons.scss';
import {faArrowCircleLeft, faArrowCircleRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const QuestionNav = props => {
  return (
    <div className="QuestionNavButtons">
      <FontAwesomeIcon icon={faArrowCircleLeft} className={"NavIcon " + (props.hasPrev || "Disabled")} onClick={props.hasPrev ? props.prevQuestion : null} />
      <FontAwesomeIcon icon={faArrowCircleRight} className={"NavIcon " + (props.hasNext || "Disabled")} onClick={props.hasNext ? props.nextQuestion : null} />
    </div>
  );
};

export default QuestionNav;
